import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import {
    createStrapiMediaUrl,
    fetchCateringEventCategoriesThunk,
    fetchCateringEventFormatsThunk,
    fetchCateringFormatsThunk,
    fetchLeadFormThunk,
} from 'shared/lib';
import { CateringFormatModelSchema } from 'entities/catering-format';
import { CateringEventCategoryModelSchema } from 'entities/catering-event-category';
import { CateringEventFormatModelSchema } from 'entities/catering-event-format';
import { CateringPageState } from './state';
import BaseError from '../../../utils/base-error';
import { CateringPageActions, GetCateringServiceActionResponseMapper } from './actions';

const initialState: CateringPageState = {
    loaded: false,
    errors: [],
    cateringFormats: [],
    cateringEventCategories: [],
    cateringEventFormats: [],

    title: 'Кейтеринг',
    image: {
        url: '', // TODO
    },
};

export const cateringPageSlice = createSlice({
    name: 'cateringPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchCateringFormatsThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.cateringFormats = response.data.data?.map(({
                            slug,
                            name,
                            description,
                            images,
                        }) => (
                            CateringFormatModelSchema.parse({
                                uid: slug,
                                name,
                                description,
                                images: images?.map(({ url }) => ({
                                    url: createStrapiMediaUrl(url),
                                })),
                                slug,
                            })
                        ));
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchCateringEventCategoriesThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.cateringEventCategories = response.data.data.map(({
                            name,
                            slug,
                        }) => (
                            CateringEventCategoryModelSchema.parse({
                                uid: slug,
                                name,
                                slug,
                            })
                        ));
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchCateringEventFormatsThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.cateringEventFormats = response.data.data?.map(({
                            name,
                            description,
                            image,
                            category,
                            slug,
                        }) => (
                            CateringEventFormatModelSchema.parse({
                                uid: slug,
                                name,
                                description,
                                image: image && {
                                    url: createStrapiMediaUrl(image.url),
                                },
                                category: category && {
                                    uid: category.slug,
                                    name: category.name,
                                    slug: category.slug,
                                },
                                slug,
                            })
                        ));
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            CateringPageActions.getCateringService.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        state.title = GetCateringServiceActionResponseMapper.getTitle(
                            response,
                        );
                        state.description = GetCateringServiceActionResponseMapper.getDescription(
                            response,
                        );
                        state.image = GetCateringServiceActionResponseMapper.getImage(
                            response,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
